<template>
    <stream-item
        icon="today"
        line-type="dashed"
        class="booking-stream-item"
    >
        <div>
        <div class="row align-items-center">
            <div class="col" style="max-width: 200px;">
                <div class="calendar">
                    <div class="calendar-top">
                        {{ data.calendar_entry.from | formatDate('MMM YY') }}
                    </div>
                    <div class="calendar-bottom">
                        {{ data.calendar_entry.from | formatDate('D') }}
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="mt-4 mr-4">{{ data.description }}</div>
                <div style="display: block; margin-top: .5rem;">
                    <a :href="$root.buildUrl('vehicles/%s/overview', [data.instance.id])" class="registration small" style="margin-top: 0; display: inline-block;">{{ data.instance.vehicle.registration.formatted_vrm }}</a>
                    <a :href="$root.buildUrl('vehicles/%s/overview', [data.instance.id])" style="display: inline-block;">{{ data.instance.title }}</a>
                </div>
                <div class="stream-item-deal-header">
                    <div class="stream-item-deal-header-left">
                        <a class="badge badge-secondary" :href="$root.buildUrl('bookings/?team=%s&starting=%s#!/booking/%s', [data.team_id, urlDate, data.id])">Booking #{{ data.id }}</a>
                    </div>
                    <stream-item-header
                        class="stream-item-deal-header-right"
                        :created-by="data.created_by"
                        :created-at="data.created_at"
                    />
                </div>
            </div>
        </div>
        </div>
    </stream-item>
</template>

<script>
    import Filters from '../../../filters'
    import StreamItem from "./StreamItem";
    import StreamItemHeader from "./StreamItemHeader";
    import Moment from 'moment'

    export default {
        filters: Filters,
        components: { StreamItem, StreamItemHeader },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        computed: {
            urlDate() {
                return Moment(this.data.calendar_entry.from).format('Y-MM-DD')
            }
        }
    }
</script>

<style lang="scss">

.booking-stream-item {
    .card { padding-top: 0; }

    .stream-item-deal-header {
        padding: 1rem 1rem 1rem 0;
        display: flex;

        .stream-item-deal-header-right {
            padding: 0 .5rem 0 0;
            flex-grow: 1;
            text-align: right;
        }
    }

    .calendar {
        text-align: center;
        border-right: 1px solid #f0f0f0;
        height: 100%;

        .calendar-top {
            background: #F3425F;
            padding: .25rem;
            color: #fff;
            text-transform: uppercase;
            font-size: .8rem;
        }

        .calendar-bottom {
            background: #fff;
            padding: 2rem .25rem;
            font-size: 3rem;
            font-weight: bold;
        }
    }
}
</style>